import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';

import { StoreSelectorService } from '../../services/shared/store-selector/store-selector.service';

export const fnbStoreGuard: CanActivateChildFn = async () => {
  const storeSelector = inject(StoreSelectorService);
  const router = inject(Router);

  await storeSelector.init();

  return storeSelector.hasFnbStore() ? true : router.parseUrl('/401');
};
